/**
 * RootLayout — top-level layout wrapping all routes.
 * Replaces Next.js app/layout.tsx (html/body tags move to index.html).
 */
import { Outlet } from 'react-router-dom'
import { Providers } from '../app/providers'
import { ErrorBoundary } from '@repo/ui'

export function RootLayout() {
  return (
    <ErrorBoundary title="Something went wrong" description="Error Details" tryAgainLabel="Try Again">
      <Providers>
        <Outlet />
      </Providers>
    </ErrorBoundary>
  )
}
